/** Editor i18n catalog: fixedWeek - the panel for fixed editors below the dashboard (Shawn 2026-11-02). English is the key source; German uses "du" and real umlauts, and never "abgeben", which also means hand in. */
import { defineMessages } from "../core.ts";

export const fixedWeek = defineMessages(
  {
    eyebrow: "Your fixed brands",
    title: "Week {week}",
    titleFreeOne: "Week {week}, 1 card still free",
    titleFreeMany: "Week {week}, {count} cards still free",
    titleRevisionOne: "Week {week}, 1 revision open",
    titleRevisionMany: "Week {week}, {count} revisions open",

    weekStripLabel: "Weekly deadline, all cards",
    bannerReleaseOne: "1 card goes to priority dispatch in {hours}h unless someone accepts it",
    bannerReleaseMany: "{count} cards go to priority dispatch in {hours}h unless someone accepts them",
    priorityIn: "Goes to priority dispatch in",
    priceComing: "Price coming",
    estimate: "~{seconds}s",

    metaBlocked: "New cards on every brand wait until your revision is handed in",
    metaBlockedHere: "No hand-ins or new cards until this revision is in",
    metaBlockedBy: "Blocked by your {brand} revision",
    pipsLabel: "This week's cards",

    chipRevision: "{count} revision",
    chipInWork: "{count} in work",
    chipOffered: "{count} offered",
    stripTitle: "Revision: do this first, it blocks everything else",
    weeklyLimit: "Weekly limit {done}/{limit}",
    allEmpty: "No cards for you on your fixed brands this week. New ones show up here.",
    dueBy: "Due {when}",
    acceptBy: "Accept by {when}",
    leftDays: "{d}d {h}h left",
    leftHours: "{h}h {m}m {s}s left",
    accept: "Accept",
    releaseFree: "No trust loss and no pause.",
    releaseFreeUntil: "No trust loss and no pause until {when}. After that the normal give-back rule applies. In the last 24h before the deadline, releasing costs {late} trust.",
    releaseLate: "Free only until {when}. Now the normal give-back rule applies: {hours}h without new offers. In the last 24h before the deadline, releasing costs {late} trust.",
    releaseLateTrust: "Free only until {when}. Now the normal give-back rule applies: {hours}h without new offers and {trust} trust. In the last 24h before the deadline, releasing costs {late} trust.",
    releaseLastDay: "Less than 24h to the deadline: releasing now costs {trust} trust and {hours}h without new offers.",
    pillOffered: "Offered",
    pillAssigned: "Assigned by client",
    pillInWork: "In work",
    pillHandedIn: "Handed in",
    pillRevision: "Revision",
    pillShare: "{name}'s share",
    pillShareOther: "Another editor's share",
    pillNextWeek: "Next week",
    pillWaitingRate: "Price coming",

    subWaitingRate: "You can accept it once the price is set.",
    subOverdue: "Past its deadline",
    subRequested: "The client asked for you.",
    subHandedIn: "Handed in {when}",

    handIn: "Hand in",
    handInRevision: "Hand in revision",
    releaseCard: "Release card",
    releaseNotePlaceholder: "Note for the client (optional, +5 trust)",
    notNow: "Not now",
    working: "One moment…",


    clientAssignedTitle: "The client asked for you",
    clientAssignedWaiting: "Waiting for you: the offer opens as soon as you can take it.",
    clientAssignedNextWeek: "This week's quota is full, it opens on Monday.",
    clientAssignedOpen: "Open",
    clientAssignedPage: "The client asked for you on this card. Accept it on your dashboard as soon as it opens there.",
    backToDashboard: "To your dashboard",
    releaseConfirm: "Do you really want to give this card to another editor?",
    releaseBody: "\"{title}\" leaves your panel and goes into priority dispatch.",
    releaseBodyFixedOnly: "\"{title}\" leaves your panel and goes to this brand's other fixed editors. If nobody can take it, Aditor steps in.",

    errShare: "This one is in another editor's share until Wednesday noon.",
    errNextWeek: "This one opens on Monday.",
    errRevision: "Hand in your open revision first.",
    errPaused: "Your offers are paused right now.",
    errRate: "This card has no price yet.",
    errGeneric: "That did not work, the list has changed. Have another look.",
    errRelease: "Could not release the card - try again.",
  },
  {
    eyebrow: "Deine festen Marken",
    title: "Woche {week}",
    titleFreeOne: "Woche {week}, 1 Card noch frei",
    titleFreeMany: "Woche {week}, {count} Cards noch frei",
    titleRevisionOne: "Woche {week}, 1 Revision offen",
    titleRevisionMany: "Woche {week}, {count} Revisionen offen",

    weekStripLabel: "Wochen-Deadline, alle Cards",
    bannerReleaseOne: "1 Card geht in {hours} h in den Prioritäts-Dispatch, wenn sie niemand annimmt",
    bannerReleaseMany: "{count} Cards gehen in {hours} h in den Prioritäts-Dispatch, wenn sie niemand annimmt",
    priorityIn: "Geht in den Prioritäts-Dispatch in",
    priceComing: "Preis folgt",
    estimate: "~{seconds} Sek.",

    metaBlocked: "Neue Cards aller Marken warten, bis deine Revision eingereicht ist",
    metaBlockedHere: "Keine Einreichungen oder neuen Cards, bis diese Revision eingereicht ist",
    metaBlockedBy: "Blockiert durch deine {brand}-Revision",
    pipsLabel: "Die Cards dieser Woche",

    chipRevision: "{count} Revision",
    chipInWork: "{count} in Arbeit",
    chipOffered: "{count} angeboten",
    stripTitle: "Revision: Das zuerst, es blockiert alles andere",
    weeklyLimit: "Wochenlimit {done}/{limit}",
    allEmpty: "Diese Woche hast du keine Cards bei deinen festen Marken. Neue erscheinen hier.",
    dueBy: "Fällig {when}",
    acceptBy: "Annehmen bis {when}",
    leftDays: "noch {d} T {h} Std.",
    leftHours: "noch {h} Std. {m} Min. {s} Sek.",
    accept: "Annehmen",
    releaseFree: "Kein Trust-Abzug und keine Pause.",
    releaseFreeUntil: "Kein Trust-Abzug und keine Pause bis {when}. Danach gilt die normale Regel fürs Zurückgeben. In den letzten 24 h vor der Deadline kostet das Freigeben {late} Trust.",
    releaseLate: "Kostenlos nur bis {when}. Jetzt gilt die normale Regel fürs Zurückgeben: {hours} h keine neuen Angebote. In den letzten 24 h vor der Deadline kostet das Freigeben {late} Trust.",
    releaseLateTrust: "Kostenlos nur bis {when}. Jetzt gilt die normale Regel fürs Zurückgeben: {hours} h keine neuen Angebote und {trust} Trust. In den letzten 24 h vor der Deadline kostet das Freigeben {late} Trust.",
    releaseLastDay: "Weniger als 24 h bis zur Deadline: Freigeben kostet jetzt {trust} Trust und {hours} h keine neuen Angebote.",
    pillOffered: "Angeboten",
    pillAssigned: "Vom Kunden zugewiesen",
    pillInWork: "In Arbeit",
    pillHandedIn: "Eingereicht",
    pillRevision: "Revision",
    pillShare: "Anteil von {name}",
    pillShareOther: "Anteil eines anderen Editors",
    pillNextWeek: "Nächste Woche",
    pillWaitingRate: "Preis folgt",

    subWaitingRate: "Annehmen geht, sobald der Preis feststeht.",
    subOverdue: "Deadline vorbei",
    subRequested: "Der Kunde hat dich angefragt.",
    subHandedIn: "Eingereicht {when}",

    handIn: "Einreichen",
    handInRevision: "Revision einreichen",
    releaseCard: "Card freigeben",
    releaseNotePlaceholder: "Notiz an den Kunden (optional, +5 Trust)",
    notNow: "Jetzt nicht",
    working: "Einen Moment …",


    clientAssignedTitle: "Der Kunde hat dich angefragt",
    clientAssignedWaiting: "Wartet auf dich: Das Angebot öffnet, sobald du sie nehmen kannst.",
    clientAssignedNextWeek: "Das Kontingent dieser Woche ist voll, sie öffnet am Montag.",
    clientAssignedOpen: "Öffnen",
    clientAssignedPage: "Der Kunde hat dich für diese Card angefragt. Nimm sie auf deinem Dashboard an, sobald sie dort öffnet.",
    backToDashboard: "Zu deinem Dashboard",
    releaseConfirm: "Möchtest du diese Card wirklich für einen anderen Editor freigeben?",
    releaseBody: "„{title}“ verlässt dein Panel und geht in den Prioritäts-Dispatch.",
    releaseBodyFixedOnly: "„{title}“ verlässt dein Panel und geht an die anderen festen Editoren dieser Marke. Kann sie niemand nehmen, kümmert sich Aditor.",

    errShare: "Diese Card gehört bis Mittwochmittag zum Anteil eines anderen Editors.",
    errNextWeek: "Diese Card öffnet am Montag.",
    errRevision: "Reich zuerst deine offene Revision ein.",
    errPaused: "Deine Angebote sind gerade pausiert.",
    errRate: "Diese Card hat noch keinen Preis.",
    errGeneric: "Das hat nicht geklappt, die Liste hat sich geändert. Schau noch mal drauf.",
    errRelease: "Die Card konnte nicht freigegeben werden - versuch es nochmal.",
  },
);
